export const setDoorData = (door) => {
  const {
    port = 0,
    display_id = "",
    status = "CLOSE",
    id = "",
    isUpdate = false,
    ip = "",
    device_id = "",
  } = door || {};
  const temp = {
    port,
    display_id,
    status,
    id,
    isUpdate,
    ip,
    device_id,
  }
  return temp;
};
